import { Sparkles, BrainCircuit, Zap, Check, X, Shield, Cpu } from "lucide-react";

export const assetImages = [
  "https://hhvzikakktakbcdbaqxj.supabase.co/storage/v1/object/public/ai-icons/placeholder-roblox-1.png",
  "https://hhvzikakktakbcdbaqxj.supabase.co/storage/v1/object/public/ai-icons/placeholder-roblox-2.png",
  "https://hhvzikakktakbcdbaqxj.supabase.co/storage/v1/object/public/ai-icons/placeholder-roblox-3.png",
  "https://hhvzikakktakbcdbaqxj.supabase.co/storage/v1/object/public/ai-icons/placeholder-roblox-4.png",
  "https://hhvzikakktakbcdbaqxj.supabase.co/storage/v1/object/public/ai-icons/placeholder-roblox-5.png",
];

export const AI_MODELS = [
  {
    id: "claude-airforce",
    name: "Claude Sonnet 4.6",
    provider: "Anthropic",
    icon: Sparkles,
    imageUrl: "https://hhvzikakktakbcdbaqxj.supabase.co/storage/v1/object/public/ai-icons/claudeai.png",
    description: "Highly intelligent and efficient architect for complex game systems.",
    inputCost: 0.05,
    outputCost: 0.25,
    isProOnly: false,
    color: "text-orange-400",
    glow: "shadow-orange-500/20",
    hasVision: true
  }
];

export const pricingPlans = [
  {
    id: "free",
    label: "Free Plan",
    badge: "Basic",
    price: "$0",
    period: "forever",
    description: "Ideal for beginners and small projects.",
    features: [
      "$5 Weekly Tokens",
      "2 messages / min",
      "Max 3 Projects",
      "Nova Fast Model Access"
    ],
    excluded: [
      "Architect Pro Models",
      "Auto Studio Sync",
      "Image Recognition",
      "Custom AI Personalization"
    ],
    cta: "Current Plan",
    ctaDisabled: true,
  },
  {
    id: "pro",
    label: "Architect Pro",
    badge: "Recommended",
    price: "$8.99",
    period: "month",
    description: "For professionals building the next top experience.",
    features: [
      "$20 Weekly Tokens",
      "5 messages / min",
      "Max 10 Projects",
      "Claude 3.5 & GPT-4o Access",
      "Auto Studio Sync",
      "Vision Capabilities",
      "Priority Support"
    ],
    excluded: [],
    cta: "Upgrade to Pro",
    ctaDisabled: false,
  },
];

export const creditPacks = [
  { id: "pack-1", label: "Sprint Pack", price: "$3.50", credits: "$10.00 Balance" },
  { id: "pack-2", label: "Studio Pack", badge: "Value", price: "$5.99", credits: "$20.00 Balance" },
  { id: "pack-3", label: "Enterprise Pack", price: "$14.99", credits: "$50.00 Balance" },
];

export const templateCards = [
  { id: "clean-start", title: "Clean Start", description: "Begin a new architectural project with a blank slate." },
  { id: "remix-favorite", title: "Remix Favorite", description: "Start with common game patterns used by professionals." },
  { id: "trending-seed", title: "Trending Seed", description: "Use experimental Luau patterns as your foundation." }
];

export const landingFeatureTabs = [
  { id: "attack-system", label: "Attack System", prompt: "Create an attack system using QPunch.", image: assetImages[0] },
  { id: "building-system", label: "Building System", prompt: "Build grid-snapped structures.", image: assetImages[3] },
  { id: "shop-system", label: "Shop with UI", prompt: "Generate a responsive shop UI.", image: assetImages[4] },
];